/*eslint-disable*/
import React from 'react';
import { Box } from '@mui/material'

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3, width: '100%', height: '100%', overflow: 'auto' }}>
            {children}
          </Box>
        )}
      </div>
    );
  }

  export default TabPanel;
